export default "__VITE_ASSET__BegASAQt__"